import { useRef, useState } from "react";
import { Alert, Box, Button, LinearProgress, Paper, Stack, Typography } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { getFidelizacionError } from "@/shared/actions/campanas/fidelizacion-campana.actions";
import { useSubirFidelizacion } from "../hooks/useFidelizacionCampana";

type Props = {
  onUploaded?: (loteId: number) => void;
  disabled?: boolean;
};

const FORMATOS = [".xlsx", ".xls", ".csv"];

export const UploadExcelCard = ({ onUploaded, disabled }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [archivo, setArchivo] = useState<File | null>(null);

  const subir = useSubirFidelizacion(onUploaded);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setArchivo(event.target.files?.[0] ?? null);
  };

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ sm: "center" }}>
        <Button
          variant="outlined"
          component="label"
          startIcon={<UploadFileIcon />}
          disabled={disabled || subir.isPending}
          sx={{ flexShrink: 0 }}
        >
          Seleccionar archivo
          <input
            ref={inputRef}
            hidden
            type="file"
            accept={FORMATOS.join(",")}
            onChange={handleChange}
          />
        </Button>

        <Typography
          variant="body2"
          color={archivo ? "text.primary" : "text.secondary"}
          noWrap
          sx={{ flex: 1, minWidth: 0 }}
        >
          {archivo ? archivo.name : "Ningún archivo seleccionado"}
        </Typography>

        <Button
          variant="contained"
          onClick={() => archivo && subir.mutate(archivo)}
          disabled={!archivo || subir.isPending || disabled}
          sx={{ minWidth: 120, flexShrink: 0 }}
        >
          {subir.isPending ? "Cargando..." : "Cargar"}
        </Button>
      </Stack>

      {subir.isPending && <LinearProgress sx={{ mt: 1.5 }} />}
      {subir.isError && (
        <Box sx={{ mt: 1.5 }}>
          <Alert severity="error">
            {getFidelizacionError(subir.error, "No se pudo cargar el archivo.")}
          </Alert>
        </Box>
      )}
    </Paper>
  );
};
